import { render, staticRenderFns } from "./InviteUserDialog.vue?vue&type=template&id=56bada1c&scoped=true"
import script from "./InviteUserDialog.vue?vue&type=script&lang=js"
export * from "./InviteUserDialog.vue?vue&type=script&lang=js"
import style0 from "./InviteUserDialog.vue?vue&type=style&index=0&id=56bada1c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bada1c",
  null
  
)

export default component.exports